import { tv, VariantProps } from "tailwind-variants";

export const progressBar = tv({
    base: [
        "tw:h-full tw:w-full tw:relative tw:bg-grey-light tw:after:content-['']",
        "tw:after:block tw:after:h-full tw:after:w-0 tw:after:absolute",
        "tw:after:top-0 tw:after:left-0 tw:after:p-0 tw:after:bg-primary"
    ],
    variants: {
        delay: {
            "3000": "tw:after:animation-duration-[3s]",
            "4000": "tw:after:animation-duration-[4s]",
            "5000": "tw:after:animation-duration-[5s]",
            "6000": "tw:after:animation-duration-[6s]",
            "7000": "tw:after:animation-duration-[7s]",
            "8000": "tw:after:animation-duration-[8s]"
        },
        isRunning: {
            true: "tw:after:animate-progress-bar tw:overflow-hidden"
        },
        isStopped: {
            true: "tw:after:w-3.5!"
        },
        isActive: {
            true: "tw:after:bg-primary",
            false: "tw:after:bg-grey-light"
        },
        rounded: {
            true: "tw:rounded-full tw:after:rounded-full"
        }
    },
    defaultVariants: {
        delay: "5000"
    }
});

export type ProgressBarVariants = VariantProps<typeof progressBar>;
